import { render, staticRenderFns } from "./WEditor.vue?vue&type=template&id=2b58a488&scoped=true"
import script from "./WEditor.vue?vue&type=script&lang=js"
export * from "./WEditor.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./WEditor.vue?vue&type=style&index=1&id=2b58a488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b58a488",
  null
  
)

export default component.exports